<div class="outer">
  <h1 *ngIf="!isAendern">{{ 'Arbeitszeit erfassen' | translate }}</h1>
  <h1 *ngIf="isAendern">{{ 'Arbeitszeit bearbeiten' | translate }}</h1>

  <!-- <ion-item lines="none">
      <ion-label position="stacked">{{ 'Art' | translate }}</ion-label>

      <ion-select placeholder="{{ 'Bitte auswählen' | translate }}" interface="popover" formControlName="name" [okText]="'OK' | translate" [cancelText]="'Abbrechen' | translate" (ionChange)="onArtChanged()">
        <ion-select-option *ngFor="let p of arbeitszeitArtenListe" [value]="p.Name">{{ p.Name }}</ion-select-option>
      </ion-select>
    </ion-item> -->

  <div class="container-item-no-padding">
    <app-input-select
                      [listItems]="arbeitszeitArtenListe"
                      titel="{{ 'Art' | translate }}"
                      placeholder=""
                      valueExpr="Name"
                      textExpr="Name"
                      (valueChanged)="onArtChanged($event)"
                      [(ngModel)]="entity.ArtName">
    </app-input-select>

    <app-input-textarea
                        titel="Bemerkung"
                        labelPosition="left"
                        [(ngModel)]="entity.Bemerkung"></app-input-textarea>
  </div>

  <!-- <ion-item lines="none">
      <ion-label position="stacked">{{ 'Dauer in min.' | translate }}</ion-label>
      <ion-input inputmode="numeric" type="text" formControlName="dauer" placeholder="Bitte eingeben" clearInput></ion-input>
    </ion-item> -->

  <div class="mt-15 buttons">
    <ion-button class="button-md" fill="solid" color="success" appClick (clicked)="onSpeichern()">OK</ion-button>
    <ion-button class="button-md" fill="solid" color="danger" appClick (clicked)="onLoeschen()" *ngIf="isAendern">Löschen</ion-button>
    <ion-button class="button-md" fill="solid" color="light" appClick (clicked)="onAbbrechen()">Abbr.</ion-button>
  </div>

  <!-- <form [formGroup]="form" *ngIf="isPause && !isAktivePause">
    <h1>{{ 'Pause ändern' | translate }}</h1>

    <ion-item lines="none">
      <ion-label position="stacked">{{ 'Dauer in min.' | translate }}</ion-label>
      <ion-input inputmode="numeric" type="text" formControlName="dauer" placeholder="Bitte eingeben" clearInput></ion-input>
    </ion-item>

    <div class="mt-15 buttons">
      <ion-button class="button-md" fill="solid" color="success" appClick (clicked)="onSpeichern()">OK</ion-button>
      <ion-button class="button-md" fill="solid" color="danger" appClick (clicked)="onLoeschen()" *ngIf="isAendern">Löschen</ion-button>
      <ion-button class="button-md" fill="solid" color="light" appClick (clicked)="onAbbrechen()">Abbr.</ion-button>
    </div>
  </form> -->

  <!-- <form [formGroup]="form" *ngIf="isPause && isAktivePause">
    <h1>{{ 'Aktuelle Pause' | translate }}</h1>

    <p>
      Pause aktiv sei {{ aktivSeit }} Uhr
    </p>

    <div class="mt-15 buttons">
      <ion-button class="button-md" fill="solid" color="danger" appClick (clicked)="onLoeschen()" *ngIf="isAendern">Löschen</ion-button>
      <ion-button class="button-md" fill="solid" color="light" appClick (clicked)="onAbbrechen()">Abbr.</ion-button>
    </div>
  </form> -->
</div>